import { useESSReferenceStore } from '../store/essReferenceStore';
import type { ESSProjectData } from '../types/essReference';
import ESS01 from '../data/ESS01_biodechets.json';
import ESS02 from '../data/ESS02_ressourcerie.json';
import ESS03 from '../data/ESS03_agroecologie.json';
import ESS04 from '../data/ESS04_regie_quartier.json';
import ESS05 from '../data/ESS05_fablab.json';

export async function importAllESSProjects(): Promise<void> {
  const store = useESSReferenceStore.getState();

  const projects = [
    ESS01 as ESSProjectData,
    ESS02 as ESSProjectData,
    ESS03 as ESSProjectData,
    ESS04 as ESSProjectData,
    ESS05 as ESSProjectData
  ];

  console.log(`🚀 Importation de ${projects.length} projets ESS de référence...`);

  for (const project of projects) {
    try {
      await store.importProjectFromJSON(project);
      console.log(`✅ Projet ${project.meta.project_id} importé: ${project.meta.project_name}`);
    } catch (error) {
      console.error(`❌ Erreur lors de l'importation du projet ${project.meta.project_id}:`, error);
    }
  }

  console.log('📊 Calcul des benchmarks sectoriels...');
  try {
    await store.refreshBenchmarks();
    console.log('✅ Benchmarks sectoriels calculés avec succès');
  } catch (error) {
    console.error('❌ Erreur lors du calcul des benchmarks:', error);
  }

  console.log('🎉 Importation terminée !');
}

export async function importSingleESSProject(jsonFile: File): Promise<void> {
  const store = useESSReferenceStore.getState();

  try {
    const content = await jsonFile.text();
    const projectData: ESSProjectData = JSON.parse(content);

    await store.importProjectFromJSON(projectData);
    console.log(`✅ Projet ${projectData.meta.project_id} importé: ${projectData.meta.project_name}`);

    await store.refreshBenchmarks();
    console.log('✅ Benchmarks sectoriels mis à jour');
  } catch (error) {
    console.error('❌ Erreur lors de l\'importation:', error);
    throw error;
  }
}

export function validateESSProject(data: any): { valid: boolean; errors: string[] } {
  const errors: string[] = [];

  if (!data.meta) {
    errors.push('Section "meta" manquante');
  } else {
    if (!data.meta.project_id) errors.push('project_id manquant dans meta');
    if (!data.meta.project_name) errors.push('project_name manquant dans meta');
    if (!data.meta.category) errors.push('category manquante dans meta');
  }

  if (!data.finance) {
    errors.push('Section "finance" manquante');
  } else {
    if (!data.finance.capex) errors.push('Section capex manquante');
    if (!data.finance.pnl) errors.push('Section pnl manquante');
    if (!data.finance.cashflow) errors.push('Section cashflow manquante');
  }

  if (!data.impact) {
    errors.push('Section "impact" manquante');
  }

  if (!data.governance) {
    errors.push('Section "governance" manquante');
  }

  return {
    valid: errors.length === 0,
    errors
  };
}
